// extracted by mini-css-extract-plugin
export var completionBody = "_ec-2";
export var completionCard = "_ec-0";
export var completionFooter = "_ec-3";
export var completionTitle = "_ec-1";